import '../App.css';
const liStyle = {
	fontSize: '16px',
	color: 'white',
	lineHeight: '1.5',
};
const Solutions = () => {
	return (
		<main>
			<div className="container">
				<div className="header-title center">
					<h1>WHAT WE OFFER</h1> 
					<p>The only place you get the best HSE Solution</p>
				</div>
				<div className="solutions-list">
				<div className="solutions-item">
					<div className="solutions-itemin" id="">
						<div className="solutions-item-pic"><img src="img/solutions1.jpg"/>
							<div className="solutions-item-text">to provide</div>
						</div>
						<div className="solutions-item-other">
							<div className="solutions-item-title">
								DEVELOP AND DESIGN HSE MANAGEMENT SYSTEMS
							</div>
						</div>
					</div>
				</div>
				<div className="solutions-item">
					<div className="solutions-itemin" id="">
						<div className="solutions-item-pic"><img src="img/solutions2.jpg"/>
							<div className="solutions-item-text">to provide</div>
						</div>
						<div className="solutions-item-other">
							<div className="solutions-item-title">
								HSE CONSULTANCY SERVICES
							</div>
						</div>
					</div>
				</div>
				<div className="solutions-item">
					<div className="solutions-itemin" id="">
						<div className="solutions-item-pic"><img src="img/solutions3.jpg"/>
							<div className="solutions-item-text">to provide</div>
						</div>
						<div className="solutions-item-other">
							<div className="solutions-item-title">
								SELLING OF INNOVATIVE HSE SOFTWARE PRODUCTS
							</div>
						</div>
					</div>
				</div>
				</div>
				<div>
					<br />
					<h2>SIMS Hazards & Risk Assessment.</h2>
					<ul>
						<li style={ liStyle }>Hazard & risk management general solutions (identifying, centralizing, integrating, development, controlling, monitoring).</li>
					</ul>
					<h2>SIMS T-Card system.</h2>
					<ul>
						<li style={ liStyle }>Safety cultural solutions.</li>
					</ul>
					<h2>SIMS reporting system.</h2>
					<ul>
						<li style={ liStyle }>Creating & managing HSE reporting system.</li>
					</ul>
					<h2>SIMS HSE E-shop.</h2>
					<ul>
						<li style={ liStyle }>Providing full list of vendors & products on HSE personal protective equipment.</li>
					</ul>
					<h2>SIMS Black Box.</h2>
					<ul>
						<li style={ liStyle }>Documentation & data storage for all HSE standards implementation requirements and auditing.</li>
					</ul>
					<h3>The Power of SIMS SOLUTIONS</h3>
					<ul>
						<li style={ liStyle }><strong>Cost-Efficient:</strong> Competitive pricing that challenges industry norms.</li>
						<li style={ liStyle }><strong>Global Reach:</strong> Multilingual support, customizable to your needs.</li>
						<li style={ liStyle }><strong>Universal Protection:</strong> Ensures safety for all levels of your organization.</li>
						<li style={ liStyle }><strong>Instant Insights:</strong> Lightning-fast results, 99% faster response time.</li>
						<li style={ liStyle }><strong>Error-Free:</strong> Leverages AI and machine learning to eliminate human errors.</li>
						<li style={ liStyle }><strong>User-Friendly:</strong> Easy implementation for everyone.</li>
						<li style={ liStyle }><strong>Knowledge Boost:</strong> AI-driven insights and solutions with references.</li>
						<li style={ liStyle }><strong>Real-Time Updates:</strong> Stay informed instantly.</li>
						<li style={ liStyle }><strong>Seamless Integration:</strong> Connects effortlessly with devices and departments.</li>
						<li style={ liStyle }><strong>Always Current:</strong> Hourly automatic updates.</li>
						<li style={ liStyle }><strong>Effortless Auditing:</strong> Constantly audits and tracks requirements.</li>
						<li style={ liStyle }><strong>Training Excellence:</strong> Simple user demos with AI support.</li>
						<li style={ liStyle }><strong>Swift Data Entry:</strong> Near-instant data input, 99% faster.</li>
						<li style={ liStyle }><strong>Cutting-Edge Tech:</strong> High-tech HSE solutions powered byAI and ML</li>
					</ul>
				</div>
			</div>
		</main>
	)
};
export default Solutions;